import { render, staticRenderFns } from "./AddCertisDialog.vue?vue&type=template&id=1b12ffcf&scoped=true"
import script from "./AddCertisDialog.vue?vue&type=script&lang=js"
export * from "./AddCertisDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCertisDialog.vue?vue&type=style&index=0&id=1b12ffcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b12ffcf",
  null
  
)

export default component.exports